/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileUpload32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlGray20}
                fillRule="nonzero"
                d="M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.bdlGray}
                d="M15.22 11.375c.4-.5 1.16-.5 1.56 0l4 5A.999.999 0 0120 18h-2.005l-.009 4.002a1 1 0 01-1 .998H15a1 1 0 01-1-1v-.002L14.007 18H12a1 1 0 01-.846-1.534l.065-.09z"
            />
        </g>
    </AccessibleSVG>
);

export default FileUpload32;
